import { NavLink, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { LayoutDashboard, FilePlus2, Truck, Users, BarChart3, Settings, LogOut } from "lucide-react";

const NavItem = ({ to, icon: Icon, label, testId, end }) => (
  <NavLink
    to={to}
    end={end}
    data-testid={testId}
    className={({ isActive }) =>
      `flex items-center gap-3 px-4 py-3 rounded-lg border-2 transition-all font-display font-semibold text-sm
       ${isActive
         ? "bg-[#F9DB81] text-black border-black shadow-[3px_3px_0_0_rgba(255,255,255,0.85)]"
         : "border-transparent text-zinc-400 hover:text-white hover:border-white/15"}`
    }
  >
    <Icon size={18} strokeWidth={2.4} />
    <span>{label}</span>
  </NavLink>
);

export const AppShell = ({ children }) => {
  const navigate = useNavigate();
  const handleLogout = () => {
    try { localStorage.removeItem("rd_authed"); } catch (_) {}
    navigate("/");
  };

  return (
    <div className="rd-grain min-h-screen flex bg-[#0A0A0A]" data-testid="app-shell">
      {/* Sidebar */}
      <aside className="hidden lg:flex flex-col w-[260px] border-r-2 border-white/10 p-6 sticky top-0 h-screen">
        <div className="mb-10"><Logo /></div>

        <nav className="flex-1 space-y-1.5">
          <div className="rd-label !text-[10px] !mb-2 !mt-2">Workspace</div>
          <NavItem to="/dashboard" end icon={LayoutDashboard} label="Active Loads" testId="nav-dashboard" />
          <NavItem to="/new-load" icon={FilePlus2} label="Book New Load" testId="nav-new-load" />

          <div className="rd-label !text-[10px] !mb-2 !mt-6">Brokerage</div>
          <NavItem to="#" icon={Truck} label="Carriers" testId="nav-carriers" />
          <NavItem to="#" icon={Users} label="Customers" testId="nav-customers" />
          <NavItem to="#" icon={BarChart3} label="Analytics" testId="nav-analytics" />
        </nav>

        <div className="mt-6 space-y-2">
          <div className="rd-card p-3 flex items-center gap-3">
            <div className="h-9 w-9 rounded-full bg-[#F9DB81] text-black flex items-center justify-center font-display font-extrabold border-2 border-black">
              JC
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold truncate">Jordan Cole</div>
              <div className="text-[10px] uppercase tracking-wider text-zinc-500">Lead Broker</div>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg border-2 border-transparent hover:border-white/15 text-zinc-400 hover:text-white font-display font-semibold text-sm transition-all"
            data-testid="logout-button"
          >
            <LogOut size={16} strokeWidth={2.4} />
            <Settings size={16} strokeWidth={2.4} className="hidden" />
            Sign out
          </button>
        </div>
      </aside>

      {/* Mobile top bar */}
      <div className="lg:hidden fixed top-0 inset-x-0 z-30 bg-[#0A0A0A] border-b-2 border-white/10 px-4 py-3 flex items-center justify-between">
        <Logo />
        <button onClick={handleLogout} className="rd-btn-secondary px-3 py-1.5 text-xs" data-testid="logout-button-mobile">
          <LogOut size={14} />
        </button>
      </div>

      <main className="flex-1 min-w-0 pt-16 lg:pt-0">{children}</main>
    </div>
  );
};
